module.exports = __webpack_public_path__ + "media/images/webpage/hotels/editor-mami-880db4c4212ee14faaab50bdd8009b93.webp";